import NetInfo from '@react-native-community/netinfo';
import {
    useEffect,
    useState
} from 'react';

export const getNetworkStatus = async () => {
    const status = await NetInfo.fetch();

    return {
        isConnected: status.isConnected ?? false,
        isReachable: status.isInternetReachable ?? false,
        type: status.type,
        isWifi: status.type === 'wifi',
        isCellular: status.type === 'cellular',
    };
};
export const useNetworkStatus = () => {
    const [ networkStatus, setNetworkStatus ] = useState({
        isConnected: false,
        isReachable: false,
        type: 'unknown',
        isWifi: false,
        isCellular: false,
    });

    useEffect(() => {
        const unsubscribe = NetInfo.addEventListener((state) => {
            console.log('unsubscribe', state);
            setNetworkStatus({
                isConnected: state.isConnected ?? false,
                isReachable: state.isInternetReachable ?? false,
                type: state.type,
                isWifi: state.type === 'wifi',
                isCellular: state.type === 'cellular',
            });
        });

        return () => unsubscribe?.();
    }, []);

    return networkStatus;
};
